import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Portal,
} from "@mui/material";

import { Cell } from "../../store/Cell";

interface Props {
  cell: Cell;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const OverwriteCellDialog: React.FC<Props> = ({
  cell,
  open,
  onClose,
  onConfirm,
}) => {
  function handleClose() {
    onClose();
  }

  function handleConfirm() {
    onConfirm();
    handleClose();
  }

  return (
    <Portal>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Overwrite {cell.label}?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {cell.label} is not empty. Pasting to this cell will overwrite its
            contents. Continue paste and overwite the cell contents?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="text"
            autoFocus
            onClick={handleConfirm}
          >
            Overwrite
          </Button>
        </DialogActions>
      </Dialog>
    </Portal>
  );
};

export default OverwriteCellDialog;
